import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Button,
  Icon,
  FormGroup,
  FormField,
  Dropdown
} from 'semantic-ui-react'

const CardConsultDetailUX = (props: any) => {
    return(
      <div
        className="ui form"
        id="CardConsultDetailUX-div-0"
        style={{padding: "30px"}}>
        <div
          id="CardConsultDetailUX-div-39"
          style={{display: "flex", justifyContent: "flex-end"}}>
          
          <div
            id="CardConsultDetailUX-div-89"
            style={{ marginRight: "10px" }}>
            {props.appStatusLabel}
          </div>
          <div
            id="CardConsultDetailUX-div-90"
            style={{ marginRight: "10px", display: props.config?.hideConsultStatus? "none": "" }}>
            {props.consultStatusLabel}
          </div>
          <div
            id="CardConsultDetailUX-div-100"
            style={{ display: props.config?.hideCloseIcon? "none": ""}}>
            
            <Icon
              id="CardConsultDetailUX-Icon-101"
              name="close"
              onClick={props.onClose}>
            </Icon>
          </div>
        </div>
        <div
          className="ui form"
          id="CardConsultDetailUX-div-42"
          style={{...(props.config.isSource ? {}: {display: "none"})}}>
          
          <FormGroup
            id="CardConsultDetailUX-FormGroup-43"
            inline={true}>
            <FormField
              id="CardConsultDetailUX-FormField-47"
              width="4">
              <div
                id="CardConsultDetailUX-div-48"
                style={{width: "100%"}}>
                
                <label
                  id="CardConsultDetailUX-label-45">
                  {props.languageUX === "en" ? "From the department" : "จากแผนก"}
                </label>
                <Dropdown
                  clearable={true}
                  disabled={props.config.sourceReadOnly}
                  fluid={true}
                  id="CardConsultDetailUX-Dropdown-49"
                  name="sourceDivision"
                  options={props.divisionList}
                  search={true}
                  selection={true}
                  value={props.consultDetail?.sourceDivision}>
                </Dropdown>
              </div>
            </FormField>
            <FormField
              id="CardConsultDetailUX-FormField-52"
              width="4">
              <div
                id="CardConsultDetailUX-div-53"
                style={{width: "100%"}}>
                {}
                <label
                  id="CardConsultDetailUX-label-51">
                  {props.languageUX === "en" ? "Physician" : "แพทย์"}
                </label>
                <Dropdown
                  clearable={true}
                  disabled={props.config.sourceReadOnly}
                  fluid={true}
                  id="CardConsultDetailUX-Dropdown-54"
                  name="sourceProviderDoctor"
                  options={props.doctorOptions}
                  search={true}
                  selection={true}
                  value={props.consultDetail?.sourceProviderDoctor}>
                </Dropdown>
              </div>
            </FormField>
            <FormField
              id="CardConsultDetailUX-FormField-71">
              <label
                id="CardConsultDetailUX-label-72">
                {props.languageUX === "en" ? "Patient" : "ผู้ป่วย"}
              </label>
            </FormField>
            <FormField
              id="CardConsultDetailUX-FormField-73">
              <div
                id="CardConsultDetailUX-div-111"
                style={{width: "100%"}}>
                
                <div
                  id="CardConsultDetailUX-div-74">
                  {props.patientDetail}
                </div>
              </div>
            </FormField>
            <FormField
              id="CardConsultDetailUX-FormField-108">
              <div
                id="CardConsultDetailUX-div-109"
                style={{display:  props?.config?.showExtraButton? "": "none"}}>
                {props.extraButton}
              </div>
            </FormField>
          </FormGroup>
        </div>
        <div
          className="ui form"
          id="CardConsultDetailUX-div-93"
          style={{...(props.config.isDestination ? {} : {display: "none"})}}>
          
          <FormGroup
            id="CardConsultDetailUX-FormGroup-57"
            inline={true}>
            <FormField
              id="CardConsultDetailUX-FormField-61"
              width="4">
              <div
                id="CardConsultDetailUX-div-62"
                style={{width: "100%"}}>
                
                <div
                  id="CardConsultDetailUX-div-110"
                  style={{display: "flex"}}>
                  
                  <label
                    id="CardConsultDetailUX-label-59">
                    {props.languageUX === "en" ? "To the department" : "ถึงแผนก"}
                  </label>
                  <div
                    id="CardConsultDetailUX-div-94"
                    style={{color: "red"}}>
                    *
                  </div>
                </div>
                <Dropdown
                  clearable={true}
                  disabled={props.config?.destinationReadOnly}
                  fluid={true}
                  id="CardConsultDetailUX-Dropdown-63"
                  name="destinationDivision"
                  onChange={props.onDivisionChange}
                  options={props.divisionTypeClinic}
                  search={true}
                  selection={true}
                  value={props.consultDetail?.destinationDivision}>
                </Dropdown>
              </div>
            </FormField>
            <FormField
              id="CardConsultDetailUX-FormField-66"
              width="3">
              <div
                id="CardConsultDetailUX-div-67"
                style={{width: "100%"}}>
                {}
                <label
                  id="CardConsultDetailUX-label-65">
                  {props.languageUX === "en" ? "Physician" : "แพทย์"}
                </label>
                <Dropdown
                  clearable={true}
                  disabled={props.config?.destinationReadOnly}
                  fluid={true}
                  id="CardConsultDetailUX-Dropdown-68"
                  name="destinationProviderDoctor"
                  onChange={props.onSelectedProviderDoctor}
                  options={props.doctorProviderOptions}
                  search={true}
                  selection={true}
                  value={props.consultDetail?.destinationProviderDoctor}>
                </Dropdown>
              </div>
            </FormField>
            <FormField
              id="CardConsultDetailUX-FormField-75"
              width="8">
              <div
                id="CardConsultDetailUX-div-95"
                style={{width: "100%"}}>
                {props.bookingComponent}
              </div>
            </FormField>
            <FormField
              id="CardConsultDetailUX-FormField-79"
              width="1">
              <div
                id="CardConsultDetailUX-div-85"
                style={{display:  props?.config?.showViewListIcon? "": "none"}}>
                {props.viewListIcon}
              </div>
            </FormField>
          </FormGroup>
        </div>
        <div
          id="CardConsultDetailUX-div-2">
          
          <label
            id="CardConsultDetailUX-label-22"
            style={{fontWeight: "bold"}}>
            {props.languageUX === "en" ? "Consultation submission details" : "รายละเอียดการส่งปรึกษา"}
          </label>
        </div>
        <div
          id="CardConsultDetailUX-div-3">
          {props.consultTextArea}
        </div>
        <div
          id="CardConsultDetailUX-div-86"
          style={{display: props.config?.hideDestinationNote ? "none" : "" }}>
          {props.languageUX === "en" ? "Reply Consult (for consulting doctors)" : "ตอบกลับ Consult (สำหรับแพทย์รับปรึกษา)"}
          <label
            id="CardConsultDetailUX-label-87"
            style={{fontWeight: "bold"}}>
            {props.languageUX === "en" ? "Consultation submission details" : "รายละเอียดการส่งปรึกษา"}
          </label>
        </div>
        <div
          id="CardConsultDetailUX-div-88"
          style={{display: props.config?.hideDestinationNote ? "none" : "" , padding: "10px 20px 10px 10px"}}>
          {props.reactConsultTextArea}
        </div>
        <div
          id="CardConsultDetailUX-div-4"
          style={{display: props.config?.hideActionBar ? "none" : "flex" , justifyContent: "flex-end", paddingRight: "15px"}}>
          
          <div
            id="CardConsultDetailUX-div-98"
            style={{ display: props.config?.hideConfirmButton ? "none" : "" }}>
            
            <Button
              color="green"
              id="CardConsultDetailUX-Button-99"
              onClick={props.onConfirmAppointment}>
              {props.languageUX === "en" ? "Confirm appointment" : "ยืนยันนัดหมาย"}
            </Button>
          </div>
          <Button
            color="green"
            disabled={props.disabledSelectDateTimeButton}
            id="CardConsultDetailUX-Button-21"
            onClick={props.onSelectDateTime}
            style={{...(props.mode !== "CREATE"? {display: "none"}: {})}}>
            <Icon
              id="CardConsultDetailUX-Icon-23"
              name="calendar alternate">
            </Icon>
            <label
              id="CardConsultDetailUX-label-24">
              {props.languageUX === "en" ? "Select appointment date and time" : "เลือกวันเวลานัดหมาย"}
            </label>
          </Button>
          <div
            id="CardConsultDetailUX-div-102"
            style={{ display: props.config?.showSelectDoctorButton && props.consultDetail?.destinationProviderDoctor === "unknown"? "" : "none" }}>
            
            <Button
              color="green"
              id="CardConsultDetailUX-Button-103"
              onClick={props.onSpecifyAppointment}>
              {props.languageUX === "en" ? "Specify the doctor and appointment time." : "ระบุแพทย์และวันเวลานัดหมาย"}
            </Button>
          </div>
          <div
            id="CardConsultDetailUX-div-96"
            style={{ display: props.config?.hideEditDateTimeButton ? "none" : "" }}>
            
            <Button
              color="yellow"
              id="CardConsultDetailUX-Button-40"
              onClick={props.onSelectDateTime}
              style={{...(props.mode !== "EDIT"? {display: "none"}: {})}}>
              {props.languageUX === "en" ? "Modify appointment date and time" : "แก้ไขวันเวลานัดหมาย"}
            </Button>
          </div>
          <div
            id="CardConsultDetailUX-div-104"
            style={{ display: props.config?.hideSaveButton ? "none" : "" }}>
            
            <Button
              color="green"
              id="CardConsultDetailUX-Button-105"
              onClick={props.onSaveConsultAppointment}
              style={{...(props.config?.hideResponseButton? {display: "none"}: {})}}>
              {props.languageUX === "en" ? "Record reply message" : "บันทึกข้อความตอบกลับ"}
            </Button>
          </div>
          <div
            id="CardConsultDetailUX-div-106"
            style={{ display: props.config?.hideEditButton ? "none" : "" }}>
            
            <Button
              color="yellow"
              id="CardConsultDetailUX-Button-107"
              onClick={props.onEditConsultAppointment}
              style={{...(props.config?.hideResponseButton? {display: "none"}: {})}}>
              {props.languageUX === "en" ? "Edit reply message" : "แก้ไขข้อความตอบกลับ"}
            </Button>
          </div>
          <div
            id="CardConsultDetailUX-div-97"
            style={{ display: props.config?.hideCancelButton ? "none" : "" }}>
            
            <Button
              color="red"
              id="CardConsultDetailUX-Button-41"
              onClick={props.onCancelAppointment}
              style={{...(props.mode !== "EDIT"? {display: "none"}: {})}}>
              {props.languageUX === "en" ? "Cancel consultation" : "ยกเลิกการส่งปรึกษา"}
            </Button>
          </div>
          <div
            id="CardConsultDetailUX-div-112"
            style={{ display: props.config?.hideFinishButton ? "none" : "" }}>
            
            <Button
              color="blue"
              id="CardConsultDetailUX-Button-113"
              onClick={props.onFinishConsult}
              type="button">
              {props.languageUX === "en" ? "Consultation completed" : "เสร็จสิ้นการ consult"}
            </Button>
          </div>
          <div
            id="CardConsultDetailUX-div-114"
            style={{ display: props.config?.hideReverseFinishButton ? "none" : "" }}>
            
            <Button
              color="orange"
              id="CardConsultDetailUX-Button-115"
              onClick={props.onReverseFinishConsult}
              type="button">
              {props.languageUX === "en" ? "Cancel completed consultation" : "ยกเลิกเสร็จสิ้นการ consult"}
            </Button>
          </div>
        </div>
      </div>
    )
}


export default CardConsultDetailUX

export const screenPropsDefault = {"language":"EN"}

/* Date Time : Thu Nov 20 2025 07:17:11 GMT+0000 (Coordinated Universal Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{padding: \"30px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 2,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-2"
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.consultTextArea"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-3"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{display: props.config?.hideActionBar ? \"none\" : \"flex\" , justifyContent: \"flex-end\", paddingRight: \"15px\"}"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 21,
      "name": "Button",
      "parent": 4,
      "props": {
        "color": {
          "type": "value",
          "value": "green"
        },
        "disabled": {
          "type": "code",
          "value": "props.disabledSelectDateTimeButton"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-Button-21"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSelectDateTime"
        },
        "style": {
          "type": "code",
          "value": "{...(props.mode !== \"CREATE\"? {display: \"none\"}: {})}"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 22,
      "name": "label",
      "parent": 2,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดการส่งปรึกษา",
          "valueEN": "Consultation submission details"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-label-22"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 22,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 23,
      "name": "Icon",
      "parent": 21,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-Icon-23"
        },
        "name": {
          "type": "value",
          "value": "calendar alternate"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "label",
      "parent": 21,
      "props": {
        "children": {
          "type": "value",
          "value": "เลือกวันเวลานัดหมาย",
          "valueEN": "Select appointment date and time"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-label-24"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 39,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-39"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"flex-end\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "Button",
      "parent": 96,
      "props": {
        "children": {
          "type": "value",
          "value": "แก้ไขวันเวลานัดหมาย",
          "valueEN": "Modify appointment date and time"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "disabled": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-Button-40"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSelectDateTime"
        },
        "style": {
          "type": "code",
          "value": "{...(props.mode !== \"EDIT\"? {display: \"none\"}: {})}"
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 41,
      "name": "Button",
      "parent": 97,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิกการส่งปรึกษา",
          "valueEN": "Cancel consultation"
        },
        "color": {
          "type": "value",
          "value": "red"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-Button-41"
        },
        "onClick": {
          "type": "code",
          "value": "props.onCancelAppointment"
        },
        "size": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{...(props.mode !== \"EDIT\"? {display: \"none\"}: {})}"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-42"
        },
        "style": {
          "type": "code",
          "value": "{...(props.config.isSource ? {}: {display: \"none\"})}"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 43,
      "name": "FormGroup",
      "parent": 42,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-FormGroup-43"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "label",
      "parent": 48,
      "props": {
        "children": {
          "type": "value",
          "value": "จากแผนก",
          "valueEN": "From the department"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-label-45"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "FormField",
      "parent": 43,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-FormField-47"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": null,
      "id": 48,
      "name": "div",
      "parent": 47,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-48"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 49,
      "name": "Dropdown",
      "parent": 48,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.config.sourceReadOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-Dropdown-49"
        },
        "name": {
          "type": "value",
          "value": "sourceDivision"
        },
        "onChange": {
          "type": "code",
          "value": ""
        },
        "onSearchChange": {
          "type": "code",
          "value": ""
        },
        "options": {
          "type": "code",
          "value": "props.divisionList"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.consultDetail?.sourceDivision"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "label",
      "parent": 53,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์",
          "valueEN": "Physician"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-label-51"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 52,
      "name": "FormField",
      "parent": 43,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-FormField-52"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "div",
      "parent": 52,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-53"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 54,
      "name": "Dropdown",
      "parent": 53,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.config.sourceReadOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-Dropdown-54"
        },
        "name": {
          "type": "value",
          "value": "sourceProviderDoctor"
        },
        "onChange": {
          "type": "code",
          "value": ""
        },
        "onSearchChange": {
          "type": "code",
          "value": ""
        },
        "options": {
          "type": "code",
          "value": "props.doctorOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.consultDetail?.sourceProviderDoctor"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 57,
      "name": "FormGroup",
      "parent": 93,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-FormGroup-57"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": ""
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "label",
      "parent": 110,
      "props": {
        "children": {
          "type": "value",
          "value": "ถึงแผนก",
          "valueEN": "To the department"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-label-59"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 61,
      "name": "FormField",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-FormField-61"
        },
        "width": {
          "type": "value",
          "value": "4"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 62,
      "name": "div",
      "parent": 61,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-62"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 63,
      "name": "Dropdown",
      "parent": 62,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.config?.destinationReadOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-Dropdown-63"
        },
        "name": {
          "type": "value",
          "value": "destinationDivision"
        },
        "onChange": {
          "type": "code",
          "value": "props.onDivisionChange"
        },
        "onSearchChange": {
          "type": "code",
          "value": ""
        },
        "options": {
          "type": "code",
          "value": "props.divisionTypeClinic"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.consultDetail?.destinationDivision"
        }
      },
      "seq": 110,
      "void": false
    },
    {
      "from": null,
      "id": 65,
      "name": "label",
      "parent": 67,
      "props": {
        "children": {
          "type": "value",
          "value": "แพทย์",
          "valueEN": "Physician"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-label-65"
        }
      },
      "seq": 65,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "FormField",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-FormField-66"
        },
        "width": {
          "type": "value",
          "value": "3"
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "div",
      "parent": 66,
      "props": {
        "children": {
          "type": "code",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-67"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 68,
      "name": "Dropdown",
      "parent": 67,
      "props": {
        "clearable": {
          "type": "code",
          "value": "true"
        },
        "disabled": {
          "type": "code",
          "value": "props.config?.destinationReadOnly"
        },
        "fluid": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-Dropdown-68"
        },
        "name": {
          "type": "value",
          "value": "destinationProviderDoctor"
        },
        "onChange": {
          "type": "code",
          "value": "props.onSelectedProviderDoctor"
        },
        "onSearchChange": {
          "type": "code",
          "value": ""
        },
        "options": {
          "type": "code",
          "value": "props.doctorProviderOptions"
        },
        "search": {
          "type": "code",
          "value": "true"
        },
        "selection": {
          "type": "code",
          "value": "true"
        },
        "value": {
          "type": "code",
          "value": "props.consultDetail?.destinationProviderDoctor"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 71,
      "name": "FormField",
      "parent": 43,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-FormField-71"
        },
        "width": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "label",
      "parent": 71,
      "props": {
        "children": {
          "type": "value",
          "value": "ผู้ป่วย",
          "valueEN": "Patient"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-label-72"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 73,
      "name": "FormField",
      "parent": 43,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-FormField-73"
        },
        "width": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": null,
      "id": 74,
      "name": "div",
      "parent": 111,
      "props": {
        "children": {
          "type": "code",
          "value": "props.patientDetail"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-74"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 75,
      "name": "FormField",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-FormField-75"
        },
        "width": {
          "type": "value",
          "value": "8"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 79,
      "name": "FormField",
      "parent": 57,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-FormField-79"
        },
        "width": {
          "type": "value",
          "value": "1"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 85,
      "name": "div",
      "parent": 79,
      "props": {
        "children": {
          "type": "code",
          "value": "props.viewListIcon"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-85"
        },
        "style": {
          "type": "code",
          "value": "{display:  props?.config?.showViewListIcon? \"\": \"none\"}"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": null,
      "id": 86,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "ตอบกลับ Consult (สำหรับแพทย์รับปรึกษา)",
          "valueEN": "Reply Consult (for consulting doctors)"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-86"
        },
        "style": {
          "type": "code",
          "value": "{display: props.config?.hideDestinationNote ? \"none\" : \"\" }"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": null,
      "id": 87,
      "name": "label",
      "parent": 86,
      "props": {
        "children": {
          "type": "value",
          "value": "รายละเอียดการส่งปรึกษา",
          "valueEN": "Consultation submission details"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-label-87"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": null,
      "id": 88,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.reactConsultTextArea"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-88"
        },
        "style": {
          "type": "code",
          "value": "{display: props.config?.hideDestinationNote ? \"none\" : \"\" , padding: \"10px 20px 10px 10px\"}"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 89,
      "name": "div",
      "parent": 39,
      "props": {
        "children": {
          "type": "code",
          "value": "props.appStatusLabel"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-89"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\" }"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 90,
      "name": "div",
      "parent": 39,
      "props": {
        "children": {
          "type": "code",
          "value": "props.consultStatusLabel"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-90"
        },
        "style": {
          "type": "code",
          "value": "{ marginRight: \"10px\", display: props.config?.hideConsultStatus? \"none\": \"\" }"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-93"
        },
        "style": {
          "type": "code",
          "value": "{...(props.config.isDestination ? {} : {display: \"none\"})}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "div",
      "parent": 110,
      "props": {
        "children": {
          "type": "value",
          "value": "*"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-94"
        },
        "style": {
          "type": "code",
          "value": "{color: \"red\"}"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 95,
      "name": "div",
      "parent": 75,
      "props": {
        "children": {
          "type": "code",
          "value": "props.bookingComponent"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-95"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 96,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-96"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.config?.hideEditDateTimeButton ? \"none\" : \"\" }"
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": null,
      "id": 97,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-97"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.config?.hideCancelButton ? \"none\" : \"\" }"
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": null,
      "id": 98,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-98"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.config?.hideConfirmButton ? \"none\" : \"\" }"
        }
      },
      "seq": 21,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 99,
      "name": "Button",
      "parent": 98,
      "props": {
        "children": {
          "type": "value",
          "value": "ยืนยันนัดหมาย",
          "valueEN": "Confirm appointment"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-Button-99"
        },
        "onClick": {
          "type": "code",
          "value": "props.onConfirmAppointment"
        },
        "size": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": null,
      "id": 100,
      "name": "div",
      "parent": 39,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-100"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.config?.hideCloseIcon? \"none\": \"\"}"
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 101,
      "name": "Icon",
      "parent": 100,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-Icon-101"
        },
        "name": {
          "type": "value",
          "value": "close"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClose"
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": null,
      "id": 102,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-102"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.config?.showSelectDoctorButton && props.consultDetail?.destinationProviderDoctor === \"unknown\"? \"\" : \"none\" }"
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 103,
      "name": "Button",
      "parent": 102,
      "props": {
        "children": {
          "type": "value",
          "value": "ระบุแพทย์และวันเวลานัดหมาย",
          "valueEN": "Specify the doctor and appointment time."
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-Button-103"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSpecifyAppointment"
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": null,
      "id": 104,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-104"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.config?.hideSaveButton ? \"none\" : \"\" }"
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "Button",
      "parent": 104,
      "props": {
        "children": {
          "type": "value",
          "value": "บันทึกข้อความตอบกลับ",
          "valueEN": "Record reply message"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-Button-105"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSaveConsultAppointment"
        },
        "size": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{...(props.config?.hideResponseButton? {display: \"none\"}: {})}"
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": null,
      "id": 106,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-106"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.config?.hideEditButton ? \"none\" : \"\" }"
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 107,
      "name": "Button",
      "parent": 106,
      "props": {
        "children": {
          "type": "value",
          "value": "แก้ไขข้อความตอบกลับ",
          "valueEN": "Edit reply message"
        },
        "color": {
          "type": "value",
          "value": "yellow"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-Button-107"
        },
        "onClick": {
          "type": "code",
          "value": "props.onEditConsultAppointment"
        },
        "size": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{...(props.config?.hideResponseButton? {display: \"none\"}: {})}"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 108,
      "name": "FormField",
      "parent": 43,
      "props": {
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-FormField-108"
        },
        "width": {
          "type": "value",
          "value": ""
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": null,
      "id": 109,
      "name": "div",
      "parent": 108,
      "props": {
        "children": {
          "type": "code",
          "value": "props.extraButton"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-109"
        },
        "style": {
          "type": "code",
          "value": "{display:  props?.config?.showExtraButton? \"\": \"none\"}"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": null,
      "id": 110,
      "name": "div",
      "parent": 62,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-110"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\"}"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": null,
      "id": 111,
      "name": "div",
      "parent": 73,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-111"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\"}"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": null,
      "id": 112,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-112"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.config?.hideFinishButton ? \"none\" : \"\" }"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 113,
      "name": "Button",
      "parent": 112,
      "props": {
        "children": {
          "type": "value",
          "value": "เสร็จสิ้นการ consult",
          "valueEN": "Consultation completed"
        },
        "color": {
          "type": "value",
          "value": "blue"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-Button-113"
        },
        "onClick": {
          "type": "code",
          "value": "props.onFinishConsult"
        },
        "size": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "value",
          "value": ""
        },
        "type": {
          "type": "value",
          "value": "button"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": null,
      "id": 114,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-div-114"
        },
        "style": {
          "type": "code",
          "value": "{ display: props.config?.hideReverseFinishButton ? \"none\" : \"\" }"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 115,
      "name": "Button",
      "parent": 114,
      "props": {
        "children": {
          "type": "value",
          "value": "ยกเลิกเสร็จสิ้นการ consult",
          "valueEN": "Cancel completed consultation"
        },
        "color": {
          "type": "value",
          "value": "orange"
        },
        "id": {
          "type": "value",
          "value": "CardConsultDetailUX-Button-115"
        },
        "onClick": {
          "type": "code",
          "value": "props.onReverseFinishConsult"
        },
        "size": {
          "type": "code",
          "value": ""
        },
        "style": {
          "type": "value",
          "value": ""
        },
        "type": {
          "type": "value",
          "value": "button"
        }
      },
      "seq": 115,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardConsultDetailUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "language": "EN"
  },
  "width": 80
}

*********************************************************************************** */
